import * as tslib_1 from "tslib";
import { OnInit, Injector, AfterViewInit } from '@angular/core';
import { Subject, combineLatest } from 'rxjs';
import { PageResolverService } from 'src/app/service/page-resolver.service';
import { Title } from '@angular/platform-browser';
import { SEOService } from 'src/app/service/seo.service';
import { Location, ViewportScroller } from '@angular/common';
import { SiteSettingsService } from 'src/app/service/site-settings.service';
import get from 'lodash.get';
import { ActivatedRoute, Router } from '@angular/router';
import { first, filter, takeUntil } from 'rxjs/operators';
import { PanelsService } from '../panels/panels.service';
var AbstractPageComponent = /** @class */ (function () {
    function AbstractPageComponent(pageResolverService, titleService, seoService, location, injector, siteSettingsService, route, viewportScroller, panelsService, router) {
        this.pageResolverService = pageResolverService;
        this.titleService = titleService;
        this.seoService = seoService;
        this.location = location;
        this.injector = injector;
        this.siteSettingsService = siteSettingsService;
        this.route = route;
        this.viewportScroller = viewportScroller;
        this.panelsService = panelsService;
        this.router = router;
        this.data = null;
        this.defaultTitle = '';
        this.alive$ = new Subject;
    }
    AbstractPageComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var utmParams, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        utmParams = this.getUtmParams(this.data);
                        if (Object.keys(utmParams).length > 0) {
                            this.router.navigate([], {
                                relativeTo: this.route,
                                queryParams: utmParams,
                                queryParamsHandling: 'merge'
                            });
                        }
                        _a = this;
                        return [4 /*yield*/, this.siteSettingsService.getSiteSettings()];
                    case 1:
                        _a.siteSettings = _b.sent();
                        this.titleService.setTitle(this.resolvePageTitle(this.data, this.siteSettings));
                        if (this.data !== null) {
                            this.seoService.addTags(this.data.metaData);
                            this.data.url && this.seoService.addCanonicalURL(this.data.url);
                            this.data.url && this.seoService.updateStructuredData(this.data.url);
                        }
                        this.handleAnchor();
                        return [2 /*return*/];
                }
            });
        });
    };
    AbstractPageComponent.prototype.ngAfterViewInit = function () {
        this.updatePageBackground();
    };
    AbstractPageComponent.prototype.handleAnchor = function () {
        var _this = this;
        var anchor$ = this.route.fragment.pipe(first());
        var lastLoadedPanelAnchor$ = this.panelsService.state$.pipe(filter(function (i) { return i !== null; }));
        var targetAnchor$ = combineLatest(anchor$, lastLoadedPanelAnchor$, function (targetAnchor, lastLoadedPanel) {
            if (targetAnchor === lastLoadedPanel.anchor)
                return targetAnchor;
        }).pipe(takeUntil(this.alive$));
        targetAnchor$.subscribe(function (fragment) { _this.handleInitialAnchor(fragment); });
    };
    AbstractPageComponent.prototype.ngOnDestroy = function () {
        this.alive$.next();
        this.alive$.complete();
    };
    AbstractPageComponent.prototype.resolvePageTitle = function (data, settings) {
        var first = get(data, 'metaData.metaTitle.value') || get(data, 'title.value') || '';
        var last = get(settings, 'headerSettings.siteTitle');
        var separator = settings.pageTitleSeparator ? " " + settings.pageTitleSeparator + " " : ' | ';
        return [first, last].filter(function (i) { return i; }).join(separator);
    };
    AbstractPageComponent.prototype.handleInitialAnchor = function (anchor) {
        if (!anchor)
            return;
        this.viewportScroller.scrollToAnchor(anchor);
    };
    AbstractPageComponent.prototype.getUtmParams = function (data) {
        return data && data.utmConfiguration ? data.utmConfiguration.value.params : {};
    };
    AbstractPageComponent.prototype.updatePageBackground = function () {
        var main = document.getElementsByTagName("main")[0];
        var screenHeight = window.screen.height;
        var backgroundContainer = document.getElementById("main-bg-image");
        if (this.data.pageBackgroundImage &&
            this.data.pageBackgroundImage.backgroundImageImage &&
            this.data.pageBackgroundImage.backgroundImageImage.value &&
            this.data.pageBackgroundImage.backgroundImageImage.value.src) {
            backgroundContainer.style.height = screenHeight + 'px';
            backgroundContainer.style.backgroundImage = "url(" + this.data.pageBackgroundImage.backgroundImageImage.value.src + ")";
            if (!this.data.pageBackgroundImage.backgroundImageRemoveOverlay.value) {
                main.classList.add("main--overlay");
            }
        }
        else {
            backgroundContainer.style.backgroundImage = '';
            main.classList.remove("main--overlay");
        }
    };
    return AbstractPageComponent;
}());
export { AbstractPageComponent };
